import React from "react";
import { BadgeProps, BadgeIndigo } from "./Badge";

export const RefundedBadge = (props: BadgeProps): React.ReactElement => (
  <BadgeIndigo {...props} icon={"ARROW_U_LEFT_TOP"}>
    Payment refunded
  </BadgeIndigo>
);
